import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface IAdminUsersFilterProps {
  formik: FormikProps<any>;
  filterRoleOptions: Array<{ id: string; name: string }>;
  filterActiveOptions: Array<{ id: string | boolean; name: string }>;
  filterHiddenOptions: Array<{ id: string | boolean; name: string }>;
}

export function AdminUsersFilter(props: IAdminUsersFilterProps) {
  const {
    formik,
    filterRoleOptions,
    filterActiveOptions,
    filterHiddenOptions,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.role')}
          name="role"
          options={filterRoleOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.active')}
          name="active"
          options={filterActiveOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.hidden')}
          name="hidden"
          options={filterHiddenOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
